define('v3/Pages/Settings/ViewModels/ReadSpeaker.ViewModel',[
	'knockout',
	'lodash',
	'v3/Common/Models/enums',
	'v3/Pages/Settings/Services/ReadSpeaker.Backend',
	'v3/Common/Services/Frontend/Frontend.Service',
	'knockout-track-changes',
	'v3/FromV2/utils'
],
function (ko, _, enums, backend, frontend) {
	function PupilModel (pupil) {
		var self = this;

		self.userId = ko.observable(pupil.userId);
		self.firstName = ko.observable(pupil.firstName);
		self.lastName = ko.observable(pupil.lastName);
		self.firstNameForSorting = ko.observable(pupil.firstNameForSorting && pupil.firstNameForSorting.trim());
		self.lastNameForSorting = ko.observable(pupil.lastNameForSorting && pupil.lastNameForSorting.trim());
		self.inFix = ko.observable(pupil.inFix);
		self.isReadSpeakerRequired = ko.observable(pupil.isReadSpeakerRequired).extend({ trackChange: true });
		self.readSpeakerReadingSpeedId = ko.observable(pupil.readSpeakerReadingSpeedId).extend({ trackChange: true });
		self.fullName = getFullPupilName(pupil);

		function getFullPupilName (pupil) {
			var name = pupil.firstName;
			if (pupil.inFix) {
				name = name + ' ' + pupil.inFix;
			}
			return name + ' ' + pupil.lastName;
		};
	}

	function ReadSpeakerViewModel (options) {
		var self = this;

		self.navBackButtonParams = options.navBackButtonParams;

		self.readingSpeed = ko.observable(0);
		self.ReadSpeaker = ko.observable({
			sentence: ko.pureComputed(function () {
				return (self.readingSpeed() === enums.readSpeakerSpeed.Slow) ? Strings.ForTheseStudentsReadingSpeedIFastEnough.split(' ').join(', ') : Strings.ForTheseStudentsReadingSpeedIFastEnough;
			}),
			readingSpeed: self.readingSpeed
		});

		self.testSpeakerReadingSpeed = function (pupil) {
			self.readingSpeed(parseInt(pupil.readSpeakerReadingSpeedId()));
			self.ReadSpeaker().play();
		};

		self.pupils = ko.observableArray([]).extend({ loading: true });

		backend.getReadSpeakerSettings().done(function (pupils) {
			var pupilModels = _.map(pupils, function (pupil) {
				return new PupilModel(pupil);
			});

			self.pupils(pupilModels);
		});

		self.isDirty = ko.computed(function () {
			var isDirty = false;
			_.each(self.pupils(), function (pupil) {
				pupil.isReadSpeakerRequired();
				pupil.readSpeakerReadingSpeedId();

				if (pupil.isReadSpeakerRequired.isDirty() || pupil.readSpeakerReadingSpeedId.isDirty()) {
					isDirty = true;
				}
			});
			return isDirty;
		}).extend({ rateLimit: 0 });

		self.totalActivePupilCount = ko.pureComputed(function () {
			return _.filter(self.pupils(), function (pupil) { return pupil.isReadSpeakerRequired(); }).length;
		});

		self.cancel = function () {
			frontend
				.confirm.show({
					content: Strings.ConfirmationBeforeSave,
					title: Strings.ConfirmSaveTitle
				})
				.then(function () {
					_.each(self.pupils(), function (pupil) {
						pupil.isReadSpeakerRequired.revertToOriginal();
						pupil.readSpeakerReadingSpeedId.revertToOriginal();
					});
				});
		};

		self.save = function () {
			var modifiedPupils = _(self.pupils())
				.filter(function (pupil) {
					return pupil.isReadSpeakerRequired.isDirty() || pupil.readSpeakerReadingSpeedId.isDirty();
				})
				.map(function (pupil) {
					return {
						UserId: ko.unwrap(pupil.userId),
						IsReadSpeakerRequired: ko.unwrap(pupil.isReadSpeakerRequired),
						ReadSpeakerReadingSpeedId: ko.unwrap(pupil.readSpeakerReadingSpeedId)
					};
				})
				.value();

			backend
				.updateReadSpeakerSettings(modifiedPupils)
				.done(function () {
					frontend.notification.success({
						text: Strings.ReadSpeakerSettingsSavedSuccesfully
					});

					_.each(self.pupils(),
						function (pupil) {
							if (pupil.isReadSpeakerRequired.isDirty() || pupil.readSpeakerReadingSpeedId.isDirty()) {
								pupil.isReadSpeakerRequired.setOriginalValue(pupil.isReadSpeakerRequired());
								pupil.isReadSpeakerRequired.valueHasMutated();
								pupil.readSpeakerReadingSpeedId.setOriginalValue(pupil.readSpeakerReadingSpeedId());
								pupil.readSpeakerReadingSpeedId.valueHasMutated();
							}
						});
				});
		};
	};

	return ReadSpeakerViewModel;
}
);
